// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d455137b","952":"ed94a7cf"}[chunkId] + ".chunk.js";
};